import React, { useState } from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import "../common/StaffingLevelsTable.css";
const StaffingLevelsTable = ({ locationCounts }) => {
  const [expandedRows, setExpandedRows] = useState({});
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const onsiteTotal = Object.entries(locationCounts)?.reduce(
    (accumulator, loc) => accumulator + loc[1]?.count?.Onsite,
    0
  );
  const remoteTotal = Object.entries(locationCounts)?.reduce(
    (accumulator, loc) => accumulator + loc[1]?.count?.Remote,
    0
  );

  const toggleRow = (location) => {
    setExpandedRows({ ...expandedRows, [location]: !expandedRows[location] });
  };

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig?.key === key && sortConfig?.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortedItems = Object?.entries(locationCounts)?.sort((a, b) => {
    if (!sortConfig?.key) return 0;

    // Handle sorting for "Location"
    if (sortConfig?.key === "Location") {
      if (a?.[0]?.toLowerCase() < b?.[0]?.toLowerCase()) {
        return sortConfig?.direction === "ascending" ? -1 : 1;
      }
      if (a?.[0]?.toLowerCase() > b?.[0]?.toLowerCase()) {
        return sortConfig?.direction === "ascending" ? 1 : -1;
      }
      return 0;
    }

    // Handle sorting for "Onsite" and "Remote"
    if (a?.[1]?.count?.[sortConfig?.key] > b?.[1]?.count?.[sortConfig?.key]) {
      return sortConfig?.direction === "ascending" ? -1 : 1;
    }
    if (a?.[1]?.count?.[sortConfig?.key] < b?.[1]?.count?.[sortConfig?.key]) {
      return sortConfig?.direction === "ascending" ? 1 : -1;
    }
    return 0;
  });

  return (
    <table className="locationTable">
      <thead>
        <tr>
          <th onClick={() => requestSort("Location")}>
            Location{" "}
            {sortConfig?.key === "Location" &&
            sortConfig?.direction === "ascending" ? (
              <FaChevronUp />
            ) : (
              <FaChevronDown />
            )}
          </th>
          <th onClick={() => requestSort("Onsite")}>
            Onsite{" "}
            {sortConfig?.key === "Onsite" &&
            sortConfig?.direction === "ascending" ? (
              <FaChevronUp />
            ) : (
              <FaChevronDown />
            )}
          </th>
          <th onClick={() => requestSort("Remote")}>
            Remote{" "}
            {sortConfig?.key === "Remote" &&
            sortConfig?.direction === "ascending" ? (
              <FaChevronUp />
            ) : (
              <FaChevronDown />
            )}
          </th>
        </tr>
      </thead>
      <tbody>
        {sortedItems?.map(([location, { count, details }]) => (
          <React.Fragment key={location}>
            <tr onClick={() => toggleRow(location)} className="locationTable">
              <td>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginLeft: "10px" }}>{location}</span>
                </div>
              </td>
              <td>{count?.Onsite || "0"}</td>
              <td>{count?.Remote || "0"}</td>
            </tr>
          </React.Fragment>
        ))}
      </tbody>
      <tfoot style={{ borderTop: "1px solid #D3D3D3" }}>
        <tr>
          <td>
            <b>Totals:</b>
          </td>
          <td>
            <b>{onsiteTotal}</b>
          </td>
          <td>
            <b>{remoteTotal}</b>
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

export default StaffingLevelsTable;
